import * as types from '../mutation-types'
import digitalCatalogService from '../services/digital_catalog'
import axios from 'axios'

// state
export const state = {
    userDetails: null,
    accessToken: localStorage.getItem('digital_catalog_access_token') || null
}

// getters
export const getters = {
    userDetails: state => state.userDetails,
    loading: state => state.loading,
    accessToken: state => state.accessToken
}

// mutations
export const mutations = {

    [types.FETCH_USER_DETAILS_SUCCESS] (state, { userDetails }) {
        state.userDetails = userDetails
    },

    [types.SET_ACCESS_TOKEN] (state, token) {
        state.accessToken = token
        localStorage.setItem('digital_catalog_access_token', token)
        // Set default header for all requests
        if (token) {
            axios.defaults.headers.common['X-Access-Token'] = token
        }
    }
}

// actions
export const actions = {
    async fetchUserDetails ({ commit }) {
        try {
            const response = await digitalCatalogService.getUserDetails()
            commit(types.FETCH_USER_DETAILS_SUCCESS, { userDetails: response.data })
            return response
        } catch (error) {
            throw error
        }
    },
    setAccessToken ({ commit }, token) {
        commit(types.SET_ACCESS_TOKEN, token)
    },
    async submitSelectedProducts ({ commit }, productIds) {
        try {
            return await digitalCatalogService.submitSelectedProducts(productIds)
        } catch (error) {
            throw error
        }
    },
    // In your checkout store (likely store/checkout.js)
    async addProductsQuantity({ commit }, payload) {
        try {
            const accessToken = localStorage.getItem('digital_catalog_access_token')
            return await digitalCatalogService.addProductsQuantity(payload, accessToken)
        } catch (error) {
            console.error('Error adding products quantity:', error)
            throw error
        }
    },
    async duplicateProductsQuantities({ commit }, payload) {
        try {
            const accessToken = localStorage.getItem('digital_catalog_access_token')
            return await digitalCatalogService.duplicateProductsQuantities(payload, accessToken)
        } catch (error) {
            console.error('Error duplicating products quantities:', error)
            throw error
        }
    },
    async addProductNotes({ commit }, payload) {
        try {
            const accessToken = localStorage.getItem('digital_catalog_access_token')
            return await digitalCatalogService.addProductNotes(payload, accessToken)
        } catch (error) {
            console.error('Error adding product notes:', error)
            throw error
        }
    },
    async deleteProductNotes({ commit }, payload) {
        try {
            const accessToken = localStorage.getItem('digital_catalog_access_token')
            return await digitalCatalogService.deleteProductNotes(payload, accessToken)
        } catch (error) {
            console.error('Error deleting product notes:', error)
            throw error
        }
    },
    async placeOrder({ commit }, payload) {
        try {
            const accessToken = localStorage.getItem('digital_catalog_access_token')
            return await digitalCatalogService.placeOrder(payload, accessToken)
        } catch (error) {
            console.error('Error placing order:', error)
            throw error
        }
    },
    // In resources/js/store/modules/digital_catalog.js actions
    async removeProduct({ commit }, payload) {
        try {
            const accessToken = localStorage.getItem('digital_catalog_access_token')
            return await digitalCatalogService.removeProduct(payload, accessToken)
        } catch (error) {
            console.error('Error removing product:', error)
            throw error
        }
    }


}
